import {Site} from 'hooks/useSiteInfo/interfaces/Site';

interface SearchAndSortProps {
  filteredSearchValue: string;
  searchSuggestions: Site[];
  filterOptions: Record<string, string>;
}

export default function searchAndSort({
  filterOptions = {},
  filteredSearchValue,
  searchSuggestions,
}: SearchAndSortProps): Site[] {
  if (!filteredSearchValue.trim()) return [];

  const list: Map<string, Site> = new Map([]);
  const filterKeys = Object.keys(filterOptions) as (keyof Site)[];
  const splitSearch: string[] = filteredSearchValue.trim().toLowerCase().split(' ');

  const sortedSuggestions = Array.from(searchSuggestions).sort((a, b) => {
    const siteCodeA = Number(a.siteCode);
    const SiteCodeB = Number(b.siteCode);
    return siteCodeA > SiteCodeB ? 1 : siteCodeA === SiteCodeB ? 0 : -1;
  });

  for (const site of sortedSuggestions) {
    const siteCodeAsInt = parseInt(site.siteCode.toString());

    if (
      list.has(site.id) ||
      (filterKeys.length &&
        !filterKeys.every((key: keyof Site) => site[key] === filterOptions[key]))
    ) {
      continue;
    }

    const siteIdMatch = splitSearch.some(searchTerm => {
      return site.siteId.toLowerCase() === searchTerm;
    });

    const siteCodeMatch = splitSearch.some(searchTerm => {
      return (
        site.siteCode.toString().toLowerCase() === searchTerm ||
        (!isNaN(siteCodeAsInt) && siteCodeAsInt === parseInt(searchTerm))
      );
    });

    const siteSearchMatch = splitSearch.every(word => {
      return site.siteSearch.startsWith(word) || site.siteSearch.includes(word);
    });

    const nposMatch = splitSearch.some(word => {
      return 'npos'.includes(word) && site.hasNpos;
    });

    if (
      splitSearch.length &&
      (siteIdMatch || siteCodeMatch || siteSearchMatch || nposMatch) === false
    ) {
      continue;
    }

    list.set(site.id, site);
  }

  const results = Array.from(list.values())
    .sort((a, b) => {
      if (filteredSearchValue === b.siteCode) return 1;
      else if (filteredSearchValue === a.siteCode) return -1;
      else return 0;
    })
    .sort((a, b) => (a.hasNpos && !b.hasNpos ? -1 : a.hasNpos && b.hasNpos ? 0 : 1));

  return results;
}
